/*
 * **Fake Engine**
 *
 * @exports bs_217
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
     * @memberOf module:bs_217
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     * Add the language case for each new hotel if needed.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {
      let lang;
      // Busy rooms demo page

      if (thn.data.propertyId === 1036998) {
        lang = document.querySelector('li.language-menu > a')?.textContent.trim();
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      if (thn.data.propertyId === 1016558) {
        lang = window.location.pathname.match(/^\/(el|hr|en)\//);
        if (lang && lang.length && ctx.langs.test(lang[1])) {
          resolve(lang[1]);
          return;
        }
      }

      // Intercontinental Hotels
      if (thn.data.accountUserId === 1034555) {
        const langs = {
          English: 'en',
          Español: 'es',
          中文: 'zh',
          PORTUGUÊS: 'pt',
        };

        lang = langs[(document.querySelector('.menu.languages a.active') || {}).innerText];
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
        // Hoteliers Demo Page
      }

      if (thn.data.propertyId === 1016556) {
        const langs = {
          English: 'en',
          Français: 'fr',
          Nederlands: 'nl',
          Deutsch: 'de',
        };

        lang = langs[((document.querySelector('.page-header__lang-select > a') || {}).textContent || '').trim()];
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      if (thn.data.propertyId === 1027221) {
        lang = window.location.pathname.match(/^\/(nl|en|de|fr)\//);
        if (lang && lang.length && ctx.langs.test(lang[1])) {
          resolve(lang[1]);
          return;
        }
      }

      if ([1156537, 1156538].includes(thn.data.propertyId)) { // Restaurants
        const langs = {
          English: 'en',
          Deutsch: 'de',
        };

        const langKey = document.querySelector('.wpml-ls-current-language span')?.textContent?.trim();
        lang = langKey && langs[langKey];
        if (lang && lang.length && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      reject('no_language');
    });
  };
  /**
     * @memberOf module:bs_217
     * @see {@link boot}
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot(ctx) {
    const navbar = document.querySelector('#DrpDwnMn0-jgk');

    if (navbar) {
      const refreshPage = thn.debounce(thn.pageCheck, 500);

      thn.observeDom(navbar, refreshPage, {
        childList: true,
        subtree: true,
        attributes: true,
      });

      thn.shutdown(() => {
        refreshPage.cancel();
        thn.stopObserveDom(navbar, refreshPage);
      });
    }
  };

  return engine;

}

export { factory };
